import Vue from 'vue'
import { BASE_URL, IMAGES_URL, DOCUMENTOS_CABECERA_URL, DOCUMENTOS_PLANTILLA_URL, DOCUMENTOS_CONTRATO_URL, DOCUMENTOS_SCORING_URL } from '@/api/api'
import { mapGetters } from 'vuex'
Vue.mixin({
  computed: {
    ...mapGetters({
      esAdministrador: 'login/esAdministrador',
      esComercial: 'login/esComercial',
      esPbc: 'login/esPbc',
      esCliente: 'login/esCliente',
      getTexto: 'textos/getTexto',
      getIdiomas: 'login/getIdiomas',
      getIdiomaDefecto: 'login/getIdiomaDefecto',
      getIdioma: 'login/getIdioma'
    }),
    desarrollo () {
      return process.env.NODE_ENV === 'development'
    },
    logo () {
      return window.logo ? window.logo : require('@/assets/images/logo.png')
    },
    esSoloCliente () {
      return !(this.esPbc || this.esAdministrador || this.esComercial)
    }
  },
  methods: {
    removeDecimalInput (valor) {
      return Number(this.$options.filters.removeDecimalInput(valor))
    },
    decimalInput (valor) {
      return this.$options.filters.decimalInput(valor)
    },
    $apiDocument (document) {
      if (document) {
        return IMAGES_URL + encodeURI(`?jsondata={"parametros":{"id":${document.id}}}`)
      } else {
        return '' // TODO DEVOLVER PLACEHOLDER
      }
    },
    $apiCabecera (document) {
      if (document) {
        return DOCUMENTOS_CABECERA_URL + encodeURI(`?jsondata={"parametros":{"id":${document.id}}}`)
      } else {
        return '' // TODO DEVOLVER PLACEHOLDER
      }
    },
    $plantillaDocumento (id) {
      return DOCUMENTOS_PLANTILLA_URL + encodeURI(`?jsondata={"parametros":{"plantillaId":${id}}}`)
    },
    $scoringDocumento (id) {
      return DOCUMENTOS_SCORING_URL + encodeURI(`?jsondata={"parametros":{"id":${id}}}`)
    },
    $contrato (id, sinFirmar = false) {
      return DOCUMENTOS_CONTRATO_URL + encodeURI(`?jsondata={"parametros":{"id":${id}, "sinFirmar":${sinFirmar}}}`)
    },
    $plantillaKycFisico () {
      return BASE_URL + '/compradores/plantilla_kyc_fisico'
    },
    $plantillaKycJuridico () {
      return BASE_URL + '/compradores/plantilla_kyc_juridico'
    },
    waitMiliseconds (ms) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, ms)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/plugins/mixins.js